import type { StatusType } from './StatusCard'

export interface StatGridItem {
  label: string
  value: string | number
  status?: StatusType
}

export interface StatGridProps {
  items: StatGridItem[]
  columns?: 2 | 3 | 4
  className?: string
}

export function StatGrid({
  items,
  columns = 3,
  className = '',
}: StatGridProps) {
  return (
    <div
      className={`stat-grid stat-grid--cols-${columns} ${className}`}
    >
      {items.map((item, index) => (
        <div key={index} className="stat-grid__item">
          <span className="stat-grid__label">{item.label}</span>
          <span className={`stat-grid__value ${item.status ? `stat-grid__value--${item.status}` : ''}`}>
            {item.value}
          </span>
        </div>
      ))}
    </div>
  )
}
